var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0807 10.1228C13.9798 10.1228 15.5257 8.5899 15.5257 6.7069C15.5257 4.82389 13.9798 3.29102 12.0807 3.29102C10.1817 3.29102 8.63574 4.82389 8.63574 6.7069C8.63574 8.5899 10.1817 10.1228 12.0807 10.1228Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7555 21.4385H5.19092V19.9249C5.19092 18.123 5.89929 16.383 7.18039 15.1106C8.44642 13.8382 10.1797 13.1123 11.9732 13.1123C13.7667 13.1123 15.5 13.8232 16.766 15.1106C18.0321 16.383 18.7555 18.123 18.7555 19.9249V21.4385Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUser);
export default __webpack_public_path__ + "static/media/single-user.3b88612b7fabc7f21928a8e2730a4cfc.svg";
export { ForwardRef as ReactComponent };